import { useEffect } from "react";
import { jwtDecode } from "jwt-decode";
import { isSessionValid } from "./authService";

// Absolute URL of the dashboard the user was sent to on their last sign-in.
// Written by the sign-in pages, read back here to bounce an already
// signed-in user off the login page.
export const POST_LOGIN_REDIRECT_KEY = "postLoginRedirect";

const isTokenExpired = (token) => {
  try {
    const { exp } = jwtDecode(token);
    return Boolean(exp) && exp * 1000 <= Date.now();
  } catch (err) {
    return true;
  }
};

// Keeps an authenticated user from landing back on a sign-in page via the
// browser Back button. Sign-in already navigates with location.replace, but
// any page *before* it in history (or a sign-in page reached through a
// pushed link) is still reachable - so the page itself checks for a live
// session and replaces itself with the user's dashboard. The pageshow
// listener covers the case where the browser restores the page from the
// back/forward cache, where mount effects don't re-run.
const useRedirectIfAuthenticated = () => {
  useEffect(() => {
    const redirectIfAuthenticated = () => {
      const target = localStorage.getItem(POST_LOGIN_REDIRECT_KEY);
      if (!target || !isSessionValid()) return;
      if (isTokenExpired(localStorage.getItem("token"))) return;
      window.location.replace(target);
    };

    redirectIfAuthenticated();

    const handlePageShow = (event) => {
      if (event.persisted) redirectIfAuthenticated();
    };
    window.addEventListener("pageshow", handlePageShow);
    return () => window.removeEventListener("pageshow", handlePageShow);
  }, []);
};

export default useRedirectIfAuthenticated;
